export default __webpack_public_path__ + "static/fallback-large-69d040c0e1d9bed81bdf75e464469b40.jpg";